import { ROLE_ENUM } from "@webkit/enums/role.enum";
import { Person } from "@models/person.model";


export class User {

  constructor(

    public username?: string,
    public password?: string,
    public person?: Person,
    public role?: ROLE_ENUM.HOST | ROLE_ENUM.GUEST

  ) { }


}